module.exports = __webpack_public_path__ + "static/media/logo2.d52e0d34.png";